import { getField, updateField } from 'vuex-map-fields'

export const state = () => ({
  nodePath: [],
  typeDialog: '',
  editDialog: false,
  customizeResponseDialog: false,
  selectNodeMode: {
    active: false,
    value: 0,
    outputResponseIndex: null,
    dialogTitle: '',
    menuJump: false
  },
  topMenu: false,
  nodeJumpSelect: {
    behavior: '',
    dialog_node: '',
    selector: ''
  }
})

export const getters = {
  getField
}

export const actions = {
}

export const mutations = {
  updateField
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
